import moment from 'moment-timezone';

export const getLocationTimezone = (locationId) => {
  switch (locationId) {
    case '1':
      return 'America/Los_Angeles'; // Las Vegas
    case '2':
      return 'America/Los_Angeles'; // Oceanside
    case '5':
      return 'Pacific/Honolulu'; // Hawaii
    case '7':
      return 'America/New_York'; // New York
    default:
      return 'UTC';
  }
};

export const getCurrentDate = async (location) => {
  //This breaks on the safari browser
  // return moment.tz(Date(), timezone).format('yyyy-MM-DD')
  const getTime = await getDateFromApi(location);
  return getTime;
};
const dateCache = {};

const getDateFromApi = async (location) => {
  // Check cache first
  if (dateCache[location]) {
    return dateCache[location];
  }

  try {
    const result = await fetch(`${process.env.REACT_APP_BOOKING_APP_API_URL}/location/${location}`);
    if (!result.ok) {
      throw new Error(`HTTP error! status: ${result.status}`);
    }
    const data = await result.json();
    if (!data || !data.currentDateTime) {
      throw new Error('Invalid response format from API');
    }
    const dateTimeString = data.currentDateTime;
    const today = dateTimeString.split(' ')[0];

    // Store in cache
    dateCache[location] = today;

    return today;
  } catch (error) {
    console.error('Error fetching date from API:', error);
    // Return current date as fallback
    return moment().format('YYYY-MM-DD');
  }
};
